import { render, staticRenderFns } from "./_algoliaTaskList.vue?vue&type=template&id=2902e9b1"
import script from "./_algoliaTaskList.vue?vue&type=script&lang=js"
export * from "./_algoliaTaskList.vue?vue&type=script&lang=js"
import style0 from "./_algoliaTaskList.vue?vue&type=style&index=0&id=2902e9b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports